import { render, staticRenderFns } from "./systemControl.vue?vue&type=template&id=b3d60f2e&scoped=true&"
import script from "./systemControl.vue?vue&type=script&lang=ts&"
export * from "./systemControl.vue?vue&type=script&lang=ts&"
import style1 from "./systemControl.vue?vue&type=style&index=1&id=b3d60f2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d60f2e",
  null
  
)

export default component.exports